<template>
  <div>
    <div align="left">
      <el-button type="primary" icon="el-icon-circle-plus" @click="showDialog">添加新的医疗企业</el-button>
      按名称或者编号模糊查询 <el-input v-model="nameOrCode" placeholder="请输入医疗企业名称或者编号" class="input" clearable>aa</el-input>
      <el-button type="primary" icon="el-icon-circle-plus" @click="search" >查询</el-button>
    </div>


    <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="100%">
      <el-table-column
        fixed
        prop="name"
        label="企业名称"
        width="300">
      </el-table-column>
      <!--<el-table-column-->
        <!--prop="id"-->
        <!--label="ID"-->
        <!--width="70">-->
      <!--</el-table-column>-->

      <!--<el-table-column-->
        <!--prop="phone"-->
        <!--label="电话"-->
        <!--width="120">-->
      <!--</el-table-column>-->
      <el-table-column
        prop="code"
        label="企业编号"
        width="100">
      </el-table-column>
      <!--<el-table-column-->
        <!--prop="addr"-->
        <!--label="地址"-->
        <!--width="160">-->
      <!--</el-table-column>-->
      <el-table-column
        prop="manager"
        label="管理员"
        width="100">
      </el-table-column>
      <el-table-column
        prop="terminal"
        label="可用投放点"
        width="160">
      </el-table-column>
      <el-table-column
        prop="line"
        label="线路"
        width="100">
      </el-table-column>

      <el-table-column
        fixed="right"
        label="操作"
        width="220">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="showModifyHospital(scope.$index, tableData)"
            size="mini" :type="'success'" >
            修改
          </el-button>
          <!--<el-button-->
            <!--@click.native.prevent="changeEnable(scope.$index, tableData)"-->
            <!--size="mini" :type="(tableData[scope.$index].state&1)==1?'danger':'success'" >-->
            <!--{{(tableData[scope.$index].state&1)==1?"停用":"启用"}}-->
          <!--</el-button>-->
        </template>
      </el-table-column>
    </el-table>


    <el-dialog title="添加新的医疗企业" :visible.sync="dialogFormVisible">
      <el-form :model="form">

        <el-form-item label="企业编号" :label-width="formLabelWidth">
          <el-input v-model="form.code" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="企业名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="线路" :label-width="formLabelWidth">
          <el-input v-model="form.lineID" autocomplete="off" clearable></el-input>
        </el-form-item>
        <!--<el-form-item label="联系电话" :label-width="formLabelWidth">-->
          <!--<el-input v-model="form.phone" autocomplete="off" clearable></el-input>-->
        <!--</el-form-item>-->
        <!--<el-form-item label="地址" :label-width="formLabelWidth">-->
          <!--<el-input v-model="form.addr" autocomplete="off" clearable></el-input>-->
        <!--</el-form-item>-->

        <!--<el-form-item label="管理员密码" :label-width="formLabelWidth">-->
          <!--<el-input v-model="form.pwd" autocomplete="off" show-password clearable></el-input>-->
        <!--</el-form-item>-->
        <!--<el-form-item label="重复管理员密码" :label-width="formLabelWidth">-->
          <!--<el-input v-model="form.rePwd" autocomplete="off" show-password clearable ></el-input>-->
        <!--</el-form-item>-->
        <!--<el-form-item label="活动区域" :label-width="formLabelWidth">-->
          <!--<el-select v-model="form.region" placeholder="请选择活动区域">-->
            <!--<el-option label="区域一" value="shanghai"></el-option>-->
            <!--<el-option label="区域二" value="beijing"></el-option>-->
          <!--</el-select>-->
        <!--</el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createHospital">添 加</el-button>
      </div>
    </el-dialog>


    <el-dialog title="修改医疗企业信息" :visible.sync="modifyHospitalVisible">
      <el-form :model="modifyHospitalForm">
        <el-form-item label="企业编号" :label-width="formLabelWidth">
          <el-input v-model="modifyHospitalForm.code" autocomplete="off" disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="企业名称" :label-width="formLabelWidth">
          <el-input v-model="modifyHospitalForm.name" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="线路" :label-width="formLabelWidth">
          <el-input v-model="modifyHospitalForm.lineID" autocomplete="off" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modifyHospitalVisible = false">取 消</el-button>
        <el-button type="primary" @click="modifyHospital">修 改</el-button>
      </div>
    </el-dialog>


    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10,20,50,100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>

</template>


<script>
  import coder from "./enum.js"
  export default {
    methods: {
      changeEnable(index, rows) {
        if (rows[index].state&1==1){
          rows[index].state^=1
        }else{
          rows[index].state|=1
        }
        //rows[index].enable=!rows[index].enable;
      },
      showModifyHospital(index, rows) {
        this.modifyHospitalForm={
          name: rows[index].name,
          code:rows[index].code,
          lineID:rows[index].line.toString()
        };
        this.modifyHospitalVisible=true;

      },

      modifyHospital(){
        console.log("createHospital:",this.form);
        if (this.modifyHospitalForm.name==""){
          this.$alert('请输入企业名称', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.modifyHospitalForm.code==""){
          this.$alert('请输入企业编号', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.modifyHospitalForm.lineID==""){
          this.$alert('请输入线路', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        let $this=this;
        window.ws.AddFunc("S2W_ModifyHospitalRes",function (code,err,info) {
          console.log(code,coder.OK,code==coder.OK);
          if (Number(code)!==coder.OK){
            $this.$alert(err+'('+code+')', '错误', {
              confirmButtonText: '确定'
            });
          }else {
            //console.log(code, err, info);
            $this.$notify({
              title: '成功',
              message: '修改企业信息成功',
              type: 'success'
            });
            $this.modifyHospitalVisible=false;
            window.ws.Call("W2S_HospitalList",$this.page,$this.pageSize,$this.nameOrCode);
          }

        });
        window.ws.Call("W2S_ModifyHospital",this.modifyHospitalForm.name,this.modifyHospitalForm.code,this.modifyHospitalForm.lineID)
      },
      search(){
        window.ws.Call("W2S_HospitalList",this.page,this.pageSize,this.nameOrCode);
      },
      showDialog(e){
        this.form={
          name: '',
          code:'',
          phone:'',
          addr:'',
          acc:'',
          pwd:'',
          rePwd:''
        };
        this.dialogFormVisible=true;
      },
      createHospital(){
        console.log("createHospital:",this.form);
        if (this.form.name==""){
          this.$alert('请输入企业名称', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.code==""){
          this.$alert('请输入企业编号', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.lineID==""){
          this.$alert('请输入线路', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        // if (this.form.phone==""){
        //   this.$alert('请输入联系电话', '错误', {
        //     confirmButtonText: '确定'
        //   });
        //   return
        // }
        // if (this.form.addr==""){
        //   this.$alert('请输入企业地址', '错误', {
        //     confirmButtonText: '确定'
        //   });
        //   return
        // }
        // if (this.form.acc==""){
        //   this.$alert('请输入管理员账号', '错误', {
        //     confirmButtonText: '确定'
        //   });
        //   return
        // }
        // if (this.form.pwd==""){
        //   this.$alert('请输入管理员密码', '错误', {
        //     confirmButtonText: '确定'
        //   });
        //   return
        // }
        // if (this.form.rePwd==""){
        //   this.$alert('请再次输入管理员密码', '错误', {
        //     confirmButtonText: '确定'
        //   });
        //   return
        // }
        // if (this.form.pwd!=this.form.rePwd){
        //   this.$alert('两次输入的密码不一致，请重新输入！', '错误', {
        //     confirmButtonText: '确定'
        //   });
        //   return
        // }
        let $this=this;
        window.ws.AddFunc("S2W_CreateHospitalRes",function (code,err,info) {
          console.log(code,coder.OK,code==coder.OK);
          if (Number(code)!==coder.OK){
            $this.$alert(err+'('+code+')', '错误', {
              confirmButtonText: '确定'
            });
          }else {
            //console.log(code, err, info);
            $this.$notify({
              title: '成功',
              message: '添加企业成功',
              type: 'success'
            });
            $this.dialogFormVisible=false;
            window.ws.Call("W2S_HospitalList",$this.page,$this.pageSize,$this.nameOrCode);
          }

        });
        window.ws.Call("W2S_CreateHospital",this.form.name,this.form.code,this.form.lineID)
        // window.ws.Call("W2S_CreateHospital",this.form.name,this.form.addr,this.form.phone,this.form.code,this.form.acc,this.form.pwd)
      },

      handleSizeChange(e){
        console.log("handleSizeChange:",e);

        this.pageSize=e;
        window.ws.Call("W2S_HospitalList",this.page,this.pageSize,this.nameOrCode);
      },
      handleCurrentChange(e){
        this.page=e;
        window.ws.Call("W2S_HospitalList",this.page,this.pageSize,this.nameOrCode);
      }
    },
    mounted() {
      let $this=this;
      console.log("###Page loaded !");
      window.ws.AddFunc("S2W_HospitalListRes",function (code,err,currentPage,total,list) {
        console.log("S2W_HospitalListRes:",code,err,currentPage,total,list)
        if (code==coder.OK){
          $this.page=currentPage;
          $this.total=total;
          $this.tableData=list;
        }
      });
      window.ws.Call("W2S_HospitalList",$this.page,$this.pageSize,$this.nameOrCode);
    },
    data() {
      return {
        page:1,
        pageSize:10,
        total:0,
        nameOrCode:'',
        tableData: [
        //   {
        //   id:"1",
        //   name:"乐山市人民医院",
        //   addr:"乐山市XXXX路xx号",
        //   phone:"13500000000",
        //   code:"100001",
        //   manager:"张三",
        //   terminal:"-",
        //   state:1,
        //   enable:true
        // }
        ],
        form: {
          name: '',
          code:'',
          phone:'',
          addr:'',
          acc:'',
          pwd:'',
          rePwd:'',
          lineID:''
        },
        modifyHospitalForm: {
          name: '',
          code:'',
          lineID:''
        },
        dialogFormVisible:false,
        modifyHospitalVisible:false,
        formLabelWidth: '120px'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/company.vue